import { useEffect, useState, useMemo } from 'react';
import { useGetModuleListMutation, useGetVerticalListMutation } from 'store/features/process/processApi';

const useSolutionConfiguration = ({ form }) => {
	const [moduleOptions, setModuleOptions] = useState([]);
	const [subModuleList, setSubModuleList] = useState([]);
	const [verticalOptions, setVerticalOptions] = useState([]);

	const [getModuleList, { data: moduleList }] = useGetModuleListMutation();
	const [getVerticalList, { data: verticalList }] = useGetVerticalListMutation();

	const verticalObjectList = useMemo(() => {
		const verticalListObject = {};

		verticalOptions?.forEach((item) => {
			verticalListObject[item.code] = item;
		});

		return verticalListObject;
	}, [verticalOptions]);

	useEffect(() => {
		getVerticalList({});
		getModuleList({});
	}, []);

	useEffect(() => {
		if (moduleList && !moduleOptions?.length) {
			const arr = [];

			for (let i = 0; i < moduleList?.listLynProcessModule?.length; i++) {
				if (moduleList?.listLynProcessModule[i]?.activationStatus === 'Active' && moduleList?.listLynProcessModule[i]?.parent === '') {
					arr.push(moduleList?.listLynProcessModule[i]);
				}
			}

			setModuleOptions(arr);
		}

		if (verticalList && !verticalOptions?.length) {
			const arr = [];

			for (let i = 0; i < verticalList?.listLynProcessVertical?.length; i++) {
				if (verticalList?.listLynProcessVertical[i]?.activationStatus === 'Active') {
					arr.push(verticalList?.listLynProcessVertical[i]);
				}
			}

			setVerticalOptions(arr);
		}
	}, [moduleList, verticalList]);

	const onModuleChange = (value) => {
		form.setFieldValue('subModule', null);

		setSubModuleList(moduleList?.listLynProcessModule?.filter((item) => item?.parent === value));
	};

	return {
		moduleOptions,
		subModuleList,
		verticalOptions,
		onModuleChange,
		verticalObjectList,
	};
};

export default useSolutionConfiguration;
